import cx from 'classnames';
import s from './VisualStatus.module.scss';

type VisualStatusProps = {
  status:  'success' | 'error' | 'warning' | 'info',
  className?: string;
}

const VisualStatus = (props: VisualStatusProps) => {
  const {
    status,
    className
  } = props;

  const statusMap = {
    success: s.online,
    error: s.offline,
    warning: s.withIssue,
    info: s.idle,
  }

  return (
    <div className={cx(s.root, statusMap[status], className)} />
  );
}

export default VisualStatus;
